const doc = [({"da":({"js":({"roles":({"select":({"choose_role":"Vælg rolle"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;